/**
 * Sistema de Espaciado - Soccer Analytics App
 * Sistema base de 4px para consistencia
 */

// Base de 4px
const baseUnit = 4;

const spacing = {
  // Valores base (en px)
  base: baseUnit,

  // Escala de espaciado (múltiplos de 4px)
  0: 0,
  0.5: baseUnit * 0.5,   // 2px
  1: baseUnit * 1,       // 4px
  1.5: baseUnit * 1.5,   // 6px
  2: baseUnit * 2,       // 8px
  2.5: baseUnit * 2.5,   // 10px
  3: baseUnit * 3,       // 12px
  3.5: baseUnit * 3.5,   // 14px
  4: baseUnit * 4,       // 16px
  5: baseUnit * 5,       // 20px
  6: baseUnit * 6,       // 24px
  7: baseUnit * 7,       // 28px
  8: baseUnit * 8,       // 32px
  9: baseUnit * 9,       // 36px
  10: baseUnit * 10,     // 40px
  11: baseUnit * 11,     // 44px
  12: baseUnit * 12,     // 48px
  14: baseUnit * 14,     // 56px
  16: baseUnit * 16,     // 64px
  20: baseUnit * 20,     // 80px
  24: baseUnit * 24,     // 96px
  32: baseUnit * 32,     // 128px
  40: baseUnit * 40,     // 160px
  48: baseUnit * 48,     // 192px
  56: baseUnit * 56,     // 224px
  64: baseUnit * 64,     // 256px

  // Valores semánticos para uso común
  xs: baseUnit * 1,      // 4px
  sm: baseUnit * 2,      // 8px
  md: baseUnit * 4,      // 16px
  lg: baseUnit * 6,      // 24px
  xl: baseUnit * 8,      // 32px
  '2xl': baseUnit * 12,  // 48px
  '3xl': baseUnit * 16,  // 64px
  '4xl': baseUnit * 24,  // 96px

  // Espaciado de componentes específicos
  component: {
    cardPadding: baseUnit * 4,        // 16px
    cardGap: baseUnit * 3,            // 12px
    buttonPadding: baseUnit * 2,      // 8px horizontal
    buttonPaddingY: baseUnit * 1.5,   // 6px vertical
    inputPadding: baseUnit * 3,       // 12px
    sectionGap: baseUnit * 6,         // 24px entre secciones
    containerPadding: baseUnit * 4,   // 16px padding de contenedores
  },

  // Layout spacing
  layout: {
    gutter: baseUnit * 4,             // 16px - espacio entre columnas
    containerPadding: {
      mobile: baseUnit * 4,           // 16px
      tablet: baseUnit * 6,           // 24px
      desktop: baseUnit * 8,          // 32px
    },
    sectionSpacing: {
      mobile: baseUnit * 8,           // 32px
      tablet: baseUnit * 12,          // 48px
      desktop: baseUnit * 16,         // 64px
    },
  },

  // Bordes redondeados
  borderRadius: {
    none: 0,
    sm: baseUnit * 0.5,    // 2px
    base: baseUnit * 1,    // 4px
    md: baseUnit * 2,      // 8px
    lg: baseUnit * 3,      // 12px
    xl: baseUnit * 4,      // 16px
    '2xl': baseUnit * 6,   // 24px
    full: 9999,            // Círculo perfecto
  },

  // Anchos de borde
  borderWidth: {
    0: 0,
    1: 1,
    2: 2,
    4: 4,
    8: 8,
  },
};

// Helper function para crear espaciado en CSS
export const createSpacing = (...values) => {
  return values.map(v => `${spacing[v] || v}px`).join(' ');
};

export default spacing;
